import { render, staticRenderFns } from "./UsersMilestones.vue?vue&type=template&id=5dd72b80&scoped=true&"
import script from "./UsersMilestones.vue?vue&type=script&lang=ts&"
export * from "./UsersMilestones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd72b80",
  null
  
)

export default component.exports